import happyPackageApi from '@/api/happyPackage/happyPackageApi.js';
import breadCrumb from '@/components/service/bread-crumb/bread-crumb.vue';

export default {
	name: 'gt-sidebar',
	mixins: [],
	extends: {},
	components: {breadCrumb},
	props: [],
	data() {
		return {
		};
	},
	computed: {

	},
	watch: {},
	created() {
	},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init(){
			if(this.$store.state.profile.productType == 'P4G'){
				this.$router.push({name: 'gt-warn'});
			}
		},
	},
};



// WEBPACK FOOTER //
// ./src/components/service/sidebar/gt-sidebar.js